import React from 'react';
import { Box, Container, Typography, useTheme } from '@mui/material';
import ProjectCard from './ProjectCard';
import Marquee from "react-fast-marquee";

const Projects = () => {
  const theme = useTheme();

  // --- START: Robust Gradient Color Logic ---
  // Get the background color from the theme.
  const bgColor = theme.palette.background.paper;

  // Try to extract the R,G,B values.
  const match = bgColor.match(/\d+/g);

  // If match is successful (color is in rgb format), join the numbers.
  // Otherwise, provide a default based on the theme mode (light/dark).
  const gradientRgb = match
    ? match.join(', ')
    : theme.palette.mode === 'dark'
      ? '18, 18, 18' // A common dark theme background color
      : '255, 255, 255'; // A common light theme background color
  // --- END: Robust Gradient Color Logic ---


  const projects = [
    {
      title: 'Secure Inventory Management System',
      description: 'An efficient and user-friendly solution designed to streamline inventory tracking, prevent stock mismatches, and enhance operational control for IT accessory businesses.',
      imageUrl: 'https://img.freepik.com/free-photo/futuristic-technology-concept_23-2151908094.jpg?t=st=1749705852~exp=1749709452~hmac=0be96a698da6f66e963371e78a5c6b699834d9f7b274a4f7b9ffab6971de7026&w=1380',
      liveUrl: '#',
      sourceUrl: '#',
    },
    {
      title: 'SmartCart E-Commerce Platform',
      description: 'A modern online shopping website offering a seamless user experience, secure checkout, and efficient product management for both customers and store owners.',
      imageUrl: 'https://img.freepik.com/free-photo/3d-rendering-cartoon-shopping-cart_23-2151680530.jpg?t=st=1749706172~exp=1749709772~hmac=d870610f0164682c514a52145218db78c2e949c113c6f1b52fe4ef6c5ad957eb&w=996',
      liveUrl: '#',
      sourceUrl: '#',
    },
    {
      title: 'Live Weather & Location Dashboard',
      description: 'Delivered real-time weather insights and location-based forecasts, helping users make informed decisions for travel, events, and daily activities based on current conditions.',
      imageUrl: 'https://img.freepik.com/free-photo/vertical-shot-pathway-middle-grassy-field-with-trees-cloudy-sky_181624-9081.jpg?t=st=1749706450~exp=1749710050~hmac=7f2ac9da544548c53d2fd740c9e8b7c5c8cd392699a15c2cf36a1fdf17eeffa5&w=996',
      liveUrl: '#',
      sourceUrl: '#',
    },
    {
      title: 'Online Learning Portal',
      description: 'Enabled educators to deliver courses and track learner progress, while providing students with seamless access to learning materials, assessments, and certification—all in one platform.',
      imageUrl: 'https://img.freepik.com/free-photo/student-class-taking-notes_23-2148888811.jpg?t=st=1749706543~exp=1749710143~hmac=51f2bbd4d088e9a56893a61c55814277087254f971abe7e9753eeaf8790ba3cb&w=996',
      liveUrl: '#',
      sourceUrl: '#',
    },
    {
      title: 'Project Management Tool',
      description: 'A collaborative tool to help teams organize tasks and meet deadlines.',
      imageUrl: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=300&h=400&fit=crop',
      liveUrl: '#',
      sourceUrl: '#',
    }
  ];

  return (
    <Box component="section" id="projects" sx={{ py: 8, backgroundColor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography variant="h4" component="h2" gutterBottom             
          sx={{
              mb: 2,
              color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[900],
              pb: 1, // padding bottom to create space for the border
              borderBottom: `4px solid ${theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main}`,
              display: 'inline-block',
              fontWeight: 'bold'
            }}
            >
            Our Projects
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Check Out Some of Our Recent Work
          </Typography>
        </Box>
      </Container>
      
      <Marquee
        pauseOnHover={true}
        speed={50}
        gradient={true}
        // Use the new, safe gradientRgb variable here
        gradientColor={gradientRgb}
        gradientWidth={100}
      >
        {projects.map((project, index) => (
          <Box key={index} sx={{ mx: 2 }}>
            <ProjectCard project={project} />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default Projects;